import { useEffect, useState } from 'react';

/**
 * Debounce any value (string, number etc.)
 * @param delay - ms debounce time
 * @param value - value expected to be changing rapidly
 */
export function useDebounce<T>(delay: number, value: T): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => clearTimeout(handler);
    }, [value, delay]);

    return debouncedValue;
}
